/* eslint-disable react/prop-types */
import { useState } from "react";
import Products from "./Products";

const ProductsPage = ({
  initialProducts,
  crossSellProducts,
  categoryId,
  loadNextCategory,
}) => {
  const [products, setProducts] = useState(initialProducts);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreProducts, setHasMoreProducts] = useState(true);
  const [loading, setLoading] = useState(false);

  const loadMoreProducts = async () => {
    if (loading || !hasMoreProducts) return;

    setLoading(true);
    const nextPage = currentPage + 1;

    try {
      const response = await fetch(
        `/api/products?page=${nextPage}&per_page=10&category=${categoryId}&orderby=title&order=asc`
      );
      const data = await response.json();

      if (data && Array.isArray(data.products)) {
        if (data.products.length > 0) {
          setProducts((prevProducts) => [...prevProducts, ...data.products]);
          setCurrentPage(nextPage);
        } else {
          setHasMoreProducts(false);
          loadNextCategory();
        }
      } else {
        setHasMoreProducts(false);
        loadNextCategory();
      }
    } catch (error) {
      console.error("Error loading more products:", error);
      setHasMoreProducts(false);
      loadNextCategory();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Products
      products={products}
      crossSellProducts={crossSellProducts}
      loadMoreProducts={loadMoreProducts}
      hasMoreProducts={hasMoreProducts}
      categoryId={categoryId}
    />
  );
};

export default ProductsPage;
